export default "__VITE_ASSET__9f05e7be__"